export var NGNIX_BASE = '/apps';
export function serializeUrl(_ref) {
  var _ref$baseUrl = _ref.baseUrl,
      baseUrl = _ref$baseUrl === void 0 ? '' : _ref$baseUrl,
      alias = _ref.alias,
      _ref$locationPath = _ref.locationPath,
      locationPath = _ref$locationPath === void 0 ? '' : _ref$locationPath;
  var appUrlPath = "".concat(alias || baseUrl).concat(locationPath);
  return appUrlPath.replace(NGNIX_BASE, '');
}
export function postInnerAppRouteChange(location, baseUrl, alias) {
  var locationPath = location.pathname,
      search = location.search;
  var path = serializeUrl({
    baseUrl: baseUrl,
    alias: alias,
    locationPath: locationPath
  });
  window.top.postMessage({
    action: 'INNER_APP_ROUTE_CHANGE',
    payload: {
      location: path,
      search: search
    }
  }, '*');
  window.top.postMessage({
    action: 'ROUTE_CHANGED',
    payload: {
      location: location,
      to: path
    }
  }, '*');
}
export function pushError(errorMessage) {
  window.top.postMessage({
    action: 'INNER_APP_ERROR',
    payload: errorMessage
  }, '*');
}
export function postRouteChangeOutOfApp(to, location) {
  var search = location.search;
  var legacyMessage = {
    action: 'ROUTE_CHANGE_OUT_OF_APP',
    payload: {
      location: to,
      search: search
    }
  };
  var message = {
    action: 'ROUTE_CHANGED_OUT_OF_APP',
    payload: {
      location: location,
      to: to
    }
  }; // For React Native Webview support

  if (window.ReactNativeWebView) {
    // It is required to stringify the message for React Native Webview
    window.ReactNativeWebView.postMessage(JSON.stringify(message));
  } else {
    window.top.postMessage(legacyMessage, '*');
    window.top.postMessage(message, '*');
  }
}
export function shouldPostBaseUrl(baseUrl, alias) {
  try {
    if (!baseUrl) {
      return false;
    }

    var serializedBaseUrl = serializeUrl({
      baseUrl: baseUrl,
      alias: alias
    });
    var location = window.top.location.pathname;
    return !location.includes(serializedBaseUrl);
  } catch (error) {
    console.error('No window found!');
    return false;
  }
}
export function init(pathname) {
  var search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var location = serializeUrl({
    locationPath: pathname
  });
  postInnerAppRouteChange(location, search);
}
export var listener = function listener(history) {
  var baseUrl = history.baseUrl,
      alias = history.alias,
      isFragment = history.isFragment,
      variant = history.variant;

  if (shouldPostBaseUrl(baseUrl, alias) && isFragment) {
    init(baseUrl);
  }

  return history.listen(function (location, action) {
    if (action === 'PUSH' || action === 'REPLACE') {
      // Do not post route change if the variant is MODULE FEDERATION
      if (variant === 'MICRO_APP') {
        return function () {};
      }

      if (history.isFragment) {
        postInnerAppRouteChange(location, baseUrl, alias);
      }
    }
  });
};